import { TASK_STATUS } from "src/constants";
import {
  LocalShippingOutlined,
  EventNoteOutlined,
  MapRounded,
  Assessment,
  Settings,
  Person,
  Warehouse,
  FilterList,
  FiberManualRecord,
  Task,
  Group,
  AccountCircle,
  Tune,
  Wallet,
  ContactPage,
  ManageAccounts,
  Category,
  CreditCard,
  Gavel,
  WhatsApp,
} from "@mui/icons-material";

export const FIRST_MILE_TABS = [
  {
    href: "/merchant",
    icon: Assessment,
    title: "Statistics",
  },
  {
    href: `/merchant/tasks/zone_orders_count?status=UNASSIGNED&shippingCompanyWarehouse=null`,
    icon: Task,
    title: "Unassigned orders",
  },
  {
    // href: "/merchant/tasks",
    icon: EventNoteOutlined,
    title: "Tasks",
    children: TASK_STATUS.map((status) => {
      return {
        icon: FiberManualRecord,
        iconStyle: { fontSize: 10 },
        listItemIconStyle: { minWidth: 17 },
        title: status.text,
        href: `/merchant/${status.path}?status=${status.value}`,
      };
    }),
  },
  {
    icon: FilterList,
    title: "Filter",
    children: [
      {
        href: "/merchant/orders/filter",
        icon: FilterList,
        title: "filterOrders",
      },
      {
        href: "/merchant/tasks/filter",
        icon: FilterList,
        title: "Tasks filter",
      },
    ],
  },
  {
    href: "/merchant/warehouse",
    icon: Warehouse,
    title: "Warehouses",
  },
  // {
  //     href: "/merchant/warehouse_guard",
  //     icon: People,
  //     title: "Warehouse supervisors",
  // },
  {
    href: "/merchant/users",
    icon: Group,
    title: "Users",
  },
  {
    href: "/merchant/drivers",
    icon: LocalShippingOutlined,
    title: "Drivers",
  },
  {
    href: "/merchant/zones",
    icon: MapRounded,
    title: "Zones",
  },
  {
    icon: Person,
    title: "Account",
    children: [
      {
        href: "/merchant/account/plans",
        icon: Category,
        title: "Plans",
      },
      {
        href: "/merchant/account/subscription",
        icon: CreditCard,
        title: "Subscription",
      },
      {
        href: "/merchant/account/settings",
        icon: ManageAccounts,
        title: "Settings",
      },
    ],
  },
  {
    href: "/merchant/customizations",
    icon: Tune,
    title: "Customizations",
  },
  {
    href: "/merchant/balance",
    icon: Wallet,
    title: "Wallet Balance",
  },
  {
    icon: WhatsApp,
    title: "Whatsapp Msgs",
    href: "/merchant/settings/whatsapp",
  },
  {
    href: "/terms-and-conditions",
    icon: Gavel,
    title: "Terms and Conditions",
  },
];
